var JoyField;
(function (JoyField) {
    JoyField["album"] = "album";
    JoyField["albums"] = "albums";
    JoyField["auth"] = "auth";
    JoyField["birthday"] = "birthday";
    JoyField["blue"] = "blue";
    JoyField["changeType"] = "changeType";
    JoyField["comment"] = "comment";
    JoyField["comments"] = "comments";
    JoyField["commentType"] = "commentType";
    JoyField["contact"] = "contact";
    JoyField["content"] = "content";
    JoyField["count"] = "count";
    JoyField["countryCode"] = "countryCode";
    JoyField["coverMedium"] = "coverMedium";
    JoyField["createdAt"] = "createdAt";
    JoyField["createdBy"] = "createdBy";
    JoyField["data"] = "data";
    JoyField["deal"] = "deal";
    JoyField["deals"] = "deals";
    JoyField["description"] = "description";
    JoyField["downloadUri"] = "downloadUri";
    JoyField["duration"] = "duration";
    JoyField["email"] = "email";
    JoyField["emails"] = "emails";
    JoyField["event"] = "event";
    JoyField["exists"] = "exists";
    JoyField["extension"] = "extension";
    JoyField["firstName"] = "firstName";
    JoyField["green"] = "green";
    JoyField["group"] = "group";
    JoyField["groups"] = "groups";
    JoyField["height"] = "height";
    JoyField["id"] = "id";
    JoyField["isAnonymous"] = "isAnonymous";
    JoyField["isPublic"] = "isPublic";
    JoyField["lastName"] = "lastName";
    JoyField["likes"] = "likes";
    JoyField["limit"] = "limit";
    JoyField["meanColor"] = "meanColor";
    JoyField["medium"] = "medium";
    JoyField["mediums"] = "mediums";
    JoyField["mimeType"] = "mimeType";
    JoyField["name"] = "name";
    JoyField["newIndex"] = "newIndex";
    JoyField["objectId"] = "objectId";
    JoyField["objectType"] = "objectType";
    JoyField["offset"] = "offset";
    JoyField["oldIndex"] = "oldIndex";
    JoyField["oldPassword"] = "oldPassword";
    JoyField["password"] = "password";
    JoyField["phone"] = "phone";
    JoyField["photoUrl"] = "photoUrl";
    JoyField["primaryEmail"] = "primaryEmail";
    JoyField["props"] = "props";
    JoyField["reason"] = "reason";
    JoyField["red"] = "red";
    JoyField["remoteSource"] = "remoteSource";
    JoyField["remoteToken"] = "remoteToken";
    JoyField["remoteUri"] = "remoteUri";
    JoyField["sessionType"] = "sessionType";
    JoyField["source"] = "source";
    JoyField["status"] = "status";
    JoyField["storageUsed"] = "storageUsed";
    JoyField["streamUriHls"] = "streamUriHls";
    JoyField["streamUriMpd"] = "streamUriMpd";
    JoyField["takenAt"] = "takenAt";
    JoyField["text"] = "text";
    JoyField["thumbnailUri"] = "thumbnailUri";
    JoyField["url"] = "url";
    JoyField["user"] = "user";
    JoyField["users"] = "users";
    JoyField["usersActive"] = "usersActive";
    JoyField["usersInactive"] = "usersInactive";
    JoyField["width"] = "width";
})(JoyField || (JoyField = {}));
export default JoyField;
//# sourceMappingURL=JoyField.js.map